import { __awaiter, __generator } from "tslib";
import { IMAGE_TYPE } from 'wix-rich-content-common';
var baseUrl = '/_serverless/ricos-media-services/media-token';
var getMediaToken = (function () {
    var mediaToken;
    return function (instance) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!mediaToken) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(baseUrl, { headers: { Authorization: instance } })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, ((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.call(response))];
                case 2:
                    mediaToken = _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/, mediaToken];
            }
        });
    }); };
})();
var getImageEditorSettings = function (instance, metaSiteId, initiator) {
    if (initiator === void 0) { initiator = 'ricos-default'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var mediaToken;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getMediaToken(instance)];
                case 1:
                    mediaToken = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.replace(/^"+|"+$/g, '');
                    if (mediaToken && mediaToken.startsWith('JWS.')) {
                        return [2 /*return*/, {
                                initiator: initiator,
                                siteToken: mediaToken,
                                metaSiteId: metaSiteId,
                                mediaRoot: 'photos',
                            }];
                    }
                    return [2 /*return*/, null];
            }
        });
    });
};
export default function imageEditorStrategy(instance, metaSiteId, userId, consumer) {
    var _a;
    if (!(instance && userId && metaSiteId))
        return {};
    var imageEditorWixSettings = getImageEditorSettings(instance, metaSiteId, consumer);
    return imageEditorWixSettings
        ? {
            config: (_a = {},
                _a[IMAGE_TYPE] = {
                    imageEditorWixSettings: imageEditorWixSettings,
                },
                _a),
        }
        : {};
}
//# sourceMappingURL=imageEditorStrategy.js.map